// Order fulfillment steps
export enum ORDER_STEP {
  ORDER_PERSONAL_STEP = 'orderPersonalStep',
  ORDER_ADDRESS_STEP = 'orderAddressStep',
  ORDER_CROSS_SELL_STEP = 'orderCrossSellStep',
  ORDER_CUSTOMER_TYPE_STEP = 'orderCustomerTypeStep',
  ORDER_PAYMENT_STEP = 'orderPaymentStep',
  ORDER_CONFIRMATION_STEP = 'orderConfirmationStep',
}

// Order fulfillment flow variants
export const ORDER_REGULAR_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 3,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 4,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: -1,
  [ORDER_STEP.ORDER_CUSTOMER_TYPE_STEP]: -2,
};

export const ORDER_CROSS_SELL_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: 3,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 4,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 5,
  [ORDER_STEP.ORDER_CUSTOMER_TYPE_STEP]: -1,
};

// we have a customer_type variant of the above to make it easier to remove the feature flag in the future
export const CUSTOMER_TYPE_ORDER_REGULAR_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_CUSTOMER_TYPE_STEP]: 3,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 4,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 5,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: -1,
};

export const CUSTOMER_TYPE_ORDER_CROSS_SELL_FLOW_STEP_INDEX = {
  [ORDER_STEP.ORDER_PERSONAL_STEP]: 1,
  [ORDER_STEP.ORDER_ADDRESS_STEP]: 2,
  [ORDER_STEP.ORDER_CROSS_SELL_STEP]: 3,
  [ORDER_STEP.ORDER_CUSTOMER_TYPE_STEP]: 4,
  [ORDER_STEP.ORDER_PAYMENT_STEP]: 5,
  [ORDER_STEP.ORDER_CONFIRMATION_STEP]: 6,
};
